<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-keyboard-shortcuts`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 9a2 2 0 00-2-2H5a2 2 0 00-2 2v30a2 2 0 002 2h38a2 2 0 002-2V9zM7 11h34v26H7V11zm30 16a1 1 0 011 1v2a1 1 0 01-1 1H11a1 1 0 01-1-1v-2a1 1 0 011-1h26zm-21-9a1 1 0 00-1-1h-4a1 1 0 00-1 1v2a1 1 0 001 1h4a1 1 0 001-1v-2zm8-1a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4zm14 1a1 1 0 00-1-1h-8a1 1 0 00-1 1v2a1 1 0 001 1h8a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconKeyboardShortcuts',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
